export default "__VITE_ASSET__lEi1KAx2__"